import React from 'react';
import './PropertyMessageCard.css';

// Mirrors mobile PropertyMessageCard.tsx's formatPrice: always show a badge,
// falling back to "Price N/A" instead of omitting it when price is 0/missing.
const formatPrice = (price) => {
  if (!price) return 'Price N/A';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(price);
};

const PropertyMessageCard = ({ propertyData, onViewProperty }) => {
  if (!propertyData) return null;

  const mlsId = propertyData.mlsId || '';
  const address = propertyData.address || '';
  const priceLabel = formatPrice(propertyData.price);
  const beds = propertyData.beds || '';
  const baths = propertyData.baths || '';
  const sqft = propertyData.sqft || '';
  const city = propertyData.city || '';
  const state = propertyData.state || '';
  const zip = propertyData.zipCode || propertyData.zip || '';
  const photo = propertyData.primaryPhoto || propertyData.photoUrl || '';

  const locationParts = [city, state].filter(Boolean).join(', ');
  const location = zip ? `${locationParts} ${zip}` : locationParts;

  return (
    <div className="pmc-card">
      <div className="pmc-image-wrapper">
        <div className="pmc-image">
          {photo ? (
            <img src={photo} alt={address || 'Property'} className="pmc-image-img" />
          ) : (
            <div className="pmc-image-placeholder">&#127968;</div>
          )}
          <div className="pmc-price-overlay">
            <span className="pmc-price-text">{priceLabel}</span>
          </div>
        </div>
      </div>

      <div className="pmc-body">
        {address && <div className="pmc-address">{address}</div>}
        {location && <div className="pmc-location">{location}</div>}

        <div className="pmc-specs">
          {/* Row 1: beds + baths side by side */}
          <div className="pmc-specs-row">
            {beds && (
              <div className="pmc-spec-item">
                <svg className="pmc-spec-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M3 7v11m0-4h18m0 4V11a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4"/>
                  <path d="M3 18h18v2H3z"/>
                </svg>
                <span>{beds} beds</span>
              </div>
            )}
            {baths && (
              <div className="pmc-spec-item">
                <svg className="pmc-spec-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M4 12h16a1 1 0 0 1 1 1v3a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-3a1 1 0 0 1 1-1z"/>
                  <path d="M6 12V5a2 2 0 0 1 2-2h3v2.25"/>
                </svg>
                <span>{baths} baths</span>
              </div>
            )}
          </div>
          {/* Row 2: sqft */}
          {sqft && (
            <div className="pmc-specs-row">
              <div className="pmc-spec-item">
                <svg className="pmc-spec-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <rect x="3" y="3" width="18" height="18" rx="2"/>
                  <path d="M3 9h18M9 3v18"/>
                </svg>
                <span>{Number(sqft).toLocaleString()} sqft</span>
              </div>
            </div>
          )}
        </div>

        {mlsId && onViewProperty && (
          <button
            className="pmc-view-btn"
            onClick={() => onViewProperty(mlsId)}
          >
            <svg className="pmc-view-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
            </svg>
            <span>View Property</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default PropertyMessageCard;
